var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBribethieves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32.602 32.602",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.531,17.138l1.153-2.621l10.271-1.677l5.139,6.289v-1.362h4.508v12.16h-4.508v-1.782l-5.66-2.306L8.387,27.618 l-7.442-3.981l0.104-1.36L0,21.226l0.733-4.298l9.119,2.937l7.232-1.992v-0.521L11.531,17.138z M9.67,14.65l-0.232,1.188 c-0.217,1.112-2.236,1.323-4.117,0.96c-1.881-0.367-3.672-1.321-3.455-2.437l0.205-1.044h0.002 c0.263-1.075,2.248-1.277,4.105-0.915c1.777,0.347,3.475,1.219,3.471,2.254L9.67,14.65z M2.932,13.531 c-0.047,0.24,0.861,1.025,2.754,1.395c1.893,0.37,3.031-0.018,3.076-0.258c0.047-0.24-0.859-1.026-2.754-1.396 C4.115,12.904,2.979,13.29,2.932,13.531z M12.371,12.123l-0.979,0.716c-0.914,0.673-2.541-0.541-3.676-2.085 C6.583,9.208,5.912,7.292,6.828,6.621l0.857-0.63l0.002,0.002c0.922-0.614,2.521,0.586,3.639,2.11 c1.072,1.46,1.728,3.251,1.023,4.011L12.371,12.123z M8.176,6.733C7.981,6.878,8.114,8.07,9.256,9.626 c1.141,1.556,2.238,2.041,2.436,1.896c0.198-0.145,0.063-1.338-1.078-2.894C9.473,7.073,8.373,6.588,8.176,6.733z M15.934,10.463 l-1.207-0.094c-1.133-0.088-1.574-2.068-1.426-3.979c0.148-1.91,0.891-3.8,2.023-3.712l1.061,0.083l-0.002,0.002 c1.101,0.136,1.528,2.088,1.381,3.974c-0.139,1.806-0.812,3.591-1.84,3.708L15.934,10.463z M16.272,3.641 c-0.244-0.019-0.922,0.973-1.07,2.896c-0.147,1.923,0.367,3.008,0.609,3.026c0.244,0.02,0.92-0.972,1.07-2.896 C17.03,4.744,16.516,3.66,16.272,3.641z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBribethieves);
export default __webpack_public_path__ + "static/media/bribethieves.d2e2c80bab09fe4c9043c88a83ac276f.svg";
export { ForwardRef as ReactComponent };